module.exports = __webpack_public_path__ + "img/whatsapp-icon-compleet.03683fe5bd91a0be21b77bab63bb219a.svg";